import React from 'react';
import PropTypes from 'prop-types';
import style from './Grid.scss';

const modificatorKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

const Row = ({ reverse, className, children, ...props }) => {
	const modificators = [style.row];
	const passingProps = {};

	Object.keys(props).forEach((key) => {
		if (modificatorKeys.includes(key)) {
			const value = props[key];
			if (value) {
				// Use camelCase
				modificators.push(`${style[key + value.charAt(0).toUpperCase() + value.slice(1)]}`);
			}
		} else {
			passingProps[key] = props[key];
		}
	});

	if (reverse) {
		modificators.push('reverse');
	}

	const classes = className ? `${className} ${modificators.join(' ')}` : modificators.join(' ');

	return (
		<div {...passingProps} className={classes}>
			{children}
		</div>
	);
};

const ModificatorType = PropTypes.oneOf(['xs', 'sm', 'md', 'lg']);

Row.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	reverse: PropTypes.bool,
	start: ModificatorType,
	center: ModificatorType,
	end: ModificatorType,
	top: ModificatorType,
	middle: ModificatorType,
	bottom: ModificatorType,
	around: ModificatorType,
	between: ModificatorType,
};

export default Row;
